module.exports = __webpack_public_path__ + "static/media/couches-11.d2a6c0dd.jpg";